export const FETCH_PACE_PRO_BANDS = 'FETCH_PACE_PRO_BANDS';
export const FETCH_PACE_PRO_BANDS_SUCCESS = 'FETCH_PACE_PRO_BANDS_SUCCESS';
export const FETCH_PACE_PRO_BANDS_FAIL = 'FETCH_PACE_PRO_BANDS_FAIL';

export const FETCH_PACE_PRO_BANDS_SUMMARY = 'FETCH_PACE_PRO_BANDS_SUMMARY';
export const FETCH_PACE_PRO_BANDS_SUMMARY_SUCCESS = 'FETCH_PACE_PRO_BANDS_SUMMARY_SUCCESS';
export const FETCH_PACE_PRO_BANDS_SUMMARY_FAIL = 'FETCH_PACE_PRO_BANDS_SUMMARY_FAIL';

export const FETCH_PACE_PRO_BAND = 'FETCH_PACE_PRO_BAND';
export const FETCH_PACE_PRO_BAND_SUCCESS = 'FETCH_PACE_PRO_BAND_SUCCESS';
export const FETCH_PACE_PRO_BAND_FAIL = 'FETCH_PACE_PRO_BAND_FAIL';

export const UPDATE_PACE_PRO_BAND = 'UPDATE_PACE_PRO_BAND';
export const UPDATE_PACE_PRO_BAND_SUCCESS = 'UPDATE_PACE_PRO_BAND_SUCCESS';
export const UPDATE_PACE_PRO_BAND_FAIL = 'UPDATE_PACE_PRO_BAND_FAIL';

export const SAVE_PACE_PRO_BAND = 'SAVE_PACE_PRO_BAND';
export const SAVE_PACE_PRO_BAND_SUCCESS = 'SAVE_PACE_PRO_BAND_SUCCESS';
export const SAVE_PACE_PRO_BAND_FAIL = 'SAVE_PACE_PRO_BAND_FAIL';

export const SEND_PACEPRO_TO_DEVICE = 'SEND_PACEPRO_TO_DEVICE';
export const SEND_PACEPRO_TO_DEVICE_SUCCESS = 'SEND_PACEPRO_TO_DEVICE_SUCCESS';
export const SEND_PACEPRO_TO_DEVICE_ERROR = 'SEND_PACEPRO_TO_DEVICE_ERROR';

export const DELETE_PACEPRO = 'DELETE_PACEPRO';
export const DELETE_PACEPRO_SUCCESS = 'DELETE_PACEPRO_SUCCESS';
export const DELETE_PACEPRO_FAIL = 'DELETE_PACEPRO_FAIL';

export const FETCH_PACE_PRO_ALGORITHM_CONFIG = 'FETCH_PACE_PRO_ALGORITHM_CONFIG';
export const FETCH_PACE_PRO_ALGORITHM_CONFIG_SUCCESS = 'FETCH_PACE_PRO_ALGORITHM_CONFIG_SUCCESS';
export const FETCH_PACE_PRO_ALGORITHM_CONFIG_FAIL = 'FETCH_PACE_PRO_ALGORITHM_CONFIG_FAIL';

export const FETCH_PACE_PRO_BAND_COURSE = 'FETCH_PACE_PRO_BAND_COURSE';
